import { render } from "./RecapCommandes.vue?vue&type=template&id=57bca8d4"
import script from "./RecapCommandes.vue?vue&type=script&lang=js"
export * from "./RecapCommandes.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jean-yvesfournet/Documents/projects/javascript/vue/shop-flash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__